import config from "../../../config"
import { storeDataDashboard, storeLinkDashboard, storeStateDashboard, storePowerBIPublic, storePowerBIPrivate, storeDatasetId } from "../../Reducers/Administrator/Dashboard"
import { notification } from 'antd'

const notificacionServidor = (type, mensaje) => {
    if(type === 'success'){
        notification['success']({
            message: 'Éxito',
            description: mensaje,
        })
    }else if(type === 'warning'){
        notification['warning']({
            message: 'Advertencia',
            description: mensaje,
        })
    }else if(type === 'error'){
        notification['error']({
            message: 'Error',
            description: mensaje,
        })
    }
}

export const getDashboardServices = async (dispatch) => {
    await fetch(config.api_url+`admin-dashboard/get-dashboard`, {
        mode:'cors',
        method: 'GET',
        headers: {
            'Accept' : 'application/json',
            'Content-type' : 'application/json',
            'usutoken': localStorage.getItem('usutoken'),
        },
    })
    .then(res => res.json())
    .then(async data => {
        console.log('API Response:', data) // Debug log
        if(data.respuesta){
            if(data.data){
                // Almacenar los datos completos con la nueva estructura
                dispatch(storeDataDashboard(data.data))
                
                // Mapear los datos específicos a los campos del formulario
                if(data.data.publico?.url) {
                    dispatch(storePowerBIPublic(data.data.publico.url))
                    // Mantener compatibilidad con el link legacy
                    dispatch(storeLinkDashboard(data.data.publico.url))
                }
                
                if(data.data.privado?.url) {
                    dispatch(storePowerBIPrivate(data.data.privado.url))
                }
                
                if(data.data.privado?.datasetId) {
                    dispatch(storeDatasetId(data.data.privado.datasetId))
                }
                
                // Estado true si tenemos datos
                dispatch(storeStateDashboard(true))
                console.log('Dashboard data loaded:', {
                    publico: data.data.publico?.url,
                    privado: data.data.privado?.url, 
                    datasetId: data.data.privado?.datasetId
                })
                // notificacionServidor('success', data.mensaje)
            }
        }else{
            notificacionServidor('error', data.mensaje)
            throw new Error(`${data.mensaje}`)
        }
    })
    .catch(error => {
        console.log('Error:', error)
        throw new Error('Los sentimos hubo un error en el servidor.')
    })
}

export const createUpdateDashboardServices = async (
    link_dashboard, 
    state_dashboard, 
    powerbi_public, 
    powerbi_private, 
    dataset_id
) => {
    const payload = {
        // Datos principales
        req_publico_url: powerbi_public,
        req_privado_url: powerbi_private,
        req_dataset_id: dataset_id,
        // Mantener compatibilidad legacy si es necesario
        req_url_deck: link_dashboard,
        req_state: state_dashboard,
    }
    
    console.log('Sending dashboard config:', payload)
    
    await fetch(config.api_url+`admin-dashboard/create-update-dashboard`, {
        mode:'cors',
        method: 'POST',
        headers: {
            'Accept' : 'application/json',
            'Content-type' : 'application/json',
            'usutoken': localStorage.getItem('usutoken'),
        },
        body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(async data => {
        if(data.response){
            notificacionServidor('success', data.message)
        }else{
            notificacionServidor('warning', data.message)
            throw new Error(`${data.message}`)
        }
    })
    .catch(error => {
        console.log(error)
        throw new Error('Los sentimos hubo un error en el servidor.')
    })
}